import { useState, useEffect, useCallback } from "react";
import api from "../../services/api";

/**
 * How each registered provider (login account) matches a directory listing, by NPI. One request for the
 * whole Manage Practices table. linkFor(accountId) returns undefined while loading, null if nothing
 * could be loaded for that account, otherwise {status, npi, organizations, ...}.
 */
export default function useProviderLinks() {
  const [byAccountId, setByAccountId] = useState(null);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const res = await api.get("/v1/admin/provider-links");
      setByAccountId(Object.fromEntries((res.data || []).map((l) => [l.providerAccountId, l])));
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || "Couldn't load organizations.");
      setByAccountId({}); // stop showing "Loading…" forever
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const linkFor = (accountId) => (byAccountId === null ? undefined : byAccountId[accountId] || null);
  return { linkFor, reload, error };
}
